module.exports = __webpack_public_path__ + "img/certificate_ogr_000362900_00.15b96e57.jpg";